import { render } from "./DaftarRTR.vue?vue&type=template&id=09fbb950"
import script from "./DaftarRTR.vue?vue&type=script&lang=js"
export * from "./DaftarRTR.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__